import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-film-line text-xl"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-extrabold text-xl text-background-50">欧美伦理</span>
                <span className="text-[11px] tracking-[0.2em] text-primary-300">ETHICAL CINEMA</span>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/90 mb-4">
              欧美伦理是一个专注欧美伦理题材影视的推荐与评论门户，涵盖电影与电视剧的剧情解析、精选专题与深度推荐，帮助观众在故事里看见人性的复杂与选择。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer">
                <i className="ri-rss-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/category/movie" className="hover:text-accent-400 transition-colors">
                浏览分类
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="text-primary-200/85 hover:text-accent-400 transition-colors">
                  欧美伦理电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-primary-200/85 hover:text-accent-400 transition-colors">
                  欧美伦理电视剧
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-200/85 hover:text-accent-400 transition-colors">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/topic/marriage" className="hover:text-accent-400 transition-colors">
                精选专题
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {topics.slice(0, 3).map((t) => (
                <li key={t.id}>
                  <Link to={`/topic/${t.id}`} className="text-primary-200/85 hover:text-accent-400 transition-colors">
                    {t.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-primary-200/85 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-200/85 hover:text-accent-400 transition-colors">
                  联系反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300">© {year} 欧美伦理 · 精选欧美伦理题材影视剧推荐与评论</p>
          <p className="text-xs text-primary-300">
            本站内容均为影视推荐与评论演示，不提供任何影视播放或下载服务。
          </p>
        </div>
      </div>
    </footer>
  );
}